import * as utils from "./utils";
import {read, view, columns, title} from './order';

export const list = utils.listFn('getMyOrders',
  function (payload, schema, columns) {
    delete payload.member_id;
    return payload;
  }, function (payload, schema, columns) {
    return {
      headers: {actas: payload.member_id},
    };
  });
export {read, view, columns, title};



// WEBPACK FOOTER //
// ./src/schemas/order-as.js